import React from 'react'
import styles from './styles.css'
import Int from 'App/components/fields/Int'
import { Field } from 'simple-react-form'

export default class EspecialValues extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          <strong>Valores Especiales</strong>
        </div>
        <div className={styles.ufForm}>
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              Tarifa Uf
              <Field placeholder="Tarifa UF" fieldName="tarifa" type={Int} />
            </div>
            <div className="col-xs-12 col-sm-6">
              UF Considerada
              <Field
                placeholder="UF Considerada"
                fieldName="valorUf"
                type={Int}
              />
            </div>
          </div>
        </div>
        <div className={styles.kit}>
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              Valor Kit
              <Field
                placeholder="ingresar valor kit"
                fieldName="valorKit"
                type={Int}
              />
            </div>
            <div className="col-xs-12 col-sm-6">
              Descuentos especiales (%)
              <Field
                placeholder="ingresar el descuento"
                fieldName="dctosEspeciales"
                type={Int}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/EspecialValues/index.js